// import { JsxElement } from 'typescript';

import { LabelColor } from "../label";

export default interface TableConfigV3 {
    tableId?: string;
    id: string;
    onRowClick?: any;
    showLoading?: boolean;
    expandable?: {
        status: boolean;
        dataIndex: string | null;
    };
    checkBoxActions?: {
        text: string;
        color: LabelColor;
        func?: string;
    }[];
    checkBox?: Boolean;
    checkboxCondition?: string;
    columns: {
        title: string;
        dataIndex?: string;
        priority?: number;
        required?: boolean;
        ellipsis?: boolean;
        condition?: string;
        cellCondition?: string;
        width?: string;
        dMap?: object;
        sorter?: boolean;
        color?: object;
        background?: object;
        permission?: string;
        type?: ColumnTypes;
        render?: any;
        numberOfButtons?: number;
        format?: (val: string) => string;
        function?: string;
        actions?: {
            func: string;
            permission?: string;
            display: {
                icon: string;
                text: any;
                condition?: any;
                color?: string;
            };
        }[];
    }[];
}

export enum SearchType {
    Genral,
    Key,
}

export enum SortingType {
    AlphaNumeric,
    Strategy,
    null,
}

export enum SortingOrders {
    Asc,
    Desc,
}

export enum ColumnTypes {
    String,
    Number,
    Money,
    Action,
    javascriptDateObject,
    Status,
    dd_mmm_yyyy,
    yyyy_mm_dd,
    Relationship,
    dateAndTime,
    Or,
    Access,
    multipleData,
    avatar,
    source,
    label,
    label2,
    Boolean,
    Tooltip,
    map,
    Switch,
    Array,
    OptionList,
    PaymentStatus,
    Custom,
}
